"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuProps = exports.Select = exports.default = void 0;
var themes_1 = require("../themes");
var Select_1 = require("@material-ui/core/Select");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(Select_1).default; } });
Object.defineProperty(exports, "Select", { enumerable: true, get: function () { return __importDefault(Select_1).default; } });
__exportStar(require("@material-ui/core/Select"), exports);
/** @deprecated Replace MenuProps with themeDefinition.props?.MuiSelect?.MenuProps from beam/dist/themes */
exports.MenuProps = (_b = (_a = themes_1.themeDefinition.props) === null || _a === void 0 ? void 0 : _a.MuiSelect) === null || _b === void 0 ? void 0 : _b.MenuProps;
//# sourceMappingURL=index.js.map